import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, info: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        this.setState({ info });
        // Optionally log to backend here
        // console.error('ErrorBoundary caught:', error, info);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen bg-slate-900 text-white p-6">
                    <div className="max-w-3xl mx-auto">
                        <h1 className="text-2xl font-bold mb-4">Something went wrong</h1>
                        <p className="text-slate-300 mb-4">The UI hit a runtime error. Details below help us fix it quickly.</p>
                        <div className="bg-slate-800 border border-slate-700 rounded p-4 overflow-auto">
                            <pre className="text-xs whitespace-pre-wrap">
                                {String(this.state.error?.message || this.state.error)}
                                {'\n'}
                                {String(this.state.info?.componentStack || '')}
                            </pre>
                        </div>
                        <button className="mt-4 bg-orange-600 hover:bg-orange-700 px-4 py-2 rounded" onClick={() => window.location.reload()}>
                            Reload
                        </button>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
